import getValidationRules from './validationRules';

import { MAIN_DATA_FIELD_NAMES } from '../constants/citizenship';

const validation = (
  formData,
  documentType,
  editedField,
  actRecordVersion,
  withBirthRegPlace
) => {
  const formObject = formData ? formData : {};
  const validateObj = Object.assign({}, formObject, { valid: true });
  const validateRules = getValidationRules(
    documentType,
    actRecordVersion,
    withBirthRegPlace
  );

  validateRules.forEach(params => {
    const {
      field,
      required,
      pattern,
      maxLength,
      minLength,
      messageRequired,
      messageFormat,
      messageLength
    } = params;
    const fieldValue = formObject[field].value;

    if (editedField === field) {
      return;
    }

    if (pattern && !new RegExp(pattern, 'gi').test(fieldValue)) {
      validateObj.valid = false;
      validateObj[field].valid = false;
      validateObj[field].message = messageFormat;
    }

    if (required && !fieldValue) {
      validateObj.valid = false;
      validateObj[field].valid = false;
      validateObj[field].message = messageRequired;
    }

    if (maxLength && fieldValue && fieldValue.length > maxLength) {
      validateObj.valid = false;
      validateObj[field].valid = false;
      validateObj[field].message = messageLength;
    }

    if (minLength && fieldValue && fieldValue.length < minLength) {
      validateObj.valid = false;
      validateObj[field].valid = false;
      validateObj[field].message = messageLength;
    }

    if (formObject.birthdate) {
      if (
        withBirthRegPlace &&
        field === MAIN_DATA_FIELD_NAMES.birthRegistrationPlace &&
        !fieldValue
      ) {
        validateObj[field].valid = false;
        validateObj[field].message = messageRequired;
      }
    }
  });

  return validateObj;
};
export default validation;
